import { createAction, props } from '@ngrx/store';
import { UserRoleModel } from '@shared/data-access/models';

export const getDetail = createAction('[User Role] GET DETAIL', props<{ item: UserRoleModel }>());
